import React, { useState } from 'react';
import axios from 'axios';
import { useUserPresencial } from '../stores/UserPresencial'
import { ApiUrl, Headers } from '../services/ApiUrl';
import { Form, Button, Container, Card, Alert, Row, Col, Badge } from 'react-bootstrap';

const initialDatosForm = {
    nombre_apellido_votante: '',
    nro_tramite: '',
    dni: '',
    anio_nac: ''
}

const VoterForm = () => {
    const [formData, setFormData] = useState(initialDatosForm);
    const [message, setMessage] = useState(null);

    const userPresencial = useUserPresencial((state) => state.userPresencial)
    const updateUserPresencial = useUserPresencial((state) => state.updateUserPresencial)
    const closeUserPresencial = useUserPresencial((state) => state.closeUserPresencial)


    const handleLogout = () => {
        // Aquí iría la lógica para cerrar sesión
        // Por ejemplo, podrías resetear el userData o llamar a una API
        closeUserPresencial()
        setFormData(initialDatosForm)
        setMessage(null)
        //console.log("Sesión cerrada");
    };

    const handleChange = (e) => {
        const { name, value } = e.target;      
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (name === 'dni' || name === 'nro_tramite' || name === 'anio_nac') {
            // Solo permite números
            const numericValue = value.replace(/[^0-9]/g, '');
            
            setFormData(prevState => ({
                ...prevState,
                [name]: numericValue
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }          
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const url = `${ApiUrl}iniciarsesionpresencial`;

        try {
            const response = await axios.post(url, formData, { headers: Headers });
            let newUser = []
            if (response.status === 200 && response.data.error === false) {
                // acá inicia sesion global
                // inicio sesión en zustand. 
                newUser = {
                    error: false,
                    login: true,
                    id_user: response.data.id_votante,
                    isVoted: false,
                    name_user: formData.nombre_apellido_votante,
                    dni: formData.dni,
                    codigo_confirm: response.data.codigo_confirm,
                    errorMsg: ""
                }
                //console.log(newUser)
                updateUserPresencial(newUser)

                //console.log(response);
                setMessage({ type: 'success', text: 'Datos enviados correctamente.' });

            }
            if (response.status === 200 && response.data.error === true) {
                //console.log(response);
                setMessage({ type: 'danger', text: response.data.mensaje });
            }
        } catch (error) {
            //console.log(error);
            setMessage({ type: 'danger', text: 'Error al enviar los datos.' });
        }
    };

    return (
        <>
        {!userPresencial.login &&
            <Container className="py-4">
                <Card className="border-0 shadow-sm">
                    <Card.Header className="bg-success text-white py-3">
                        <h4 className="mb-0">
                            <i className="bi bi-person-plus-fill me-2"></i>
                            Registro de Votante Presencial
                        </h4>
                    </Card.Header>
                    <Card.Body className="p-4">
                        {message && (
                            <Alert 
                                variant={message.type} 
                                onClose={() => setMessage(null)} 
                                dismissible
                                className="d-flex align-items-center"
                            >
                                <i className={`bi bi-${message.type === 'success' ? 'check-circle' : 'exclamation-circle'}-fill me-2`}></i>
                                {message.text}
                            </Alert>
                        )}
                        
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            <i className="bi bi-person me-2"></i>
                                            Nombre y Apellido
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="nombre_apellido_votante"
                                            value={formData.nombre_apellido_votante}
                                            onChange={handleChange}
                                            required
                                            placeholder="Ingrese nombre y apellido..."
                                            className="shadow-sm"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            <i className="bi bi-person-vcard me-2"></i>
                                            Número de DNI
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="dni"
                                            value={formData.dni}
                                            onChange={handleChange}
                                            pattern="[0-9]{7,}"
                                            title="Debe ingresar mínimo 7 números"
                                            minLength={7}
                                            required
                                            placeholder="Ingrese su DNI..."
                                            className="shadow-sm"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            <i className="bi bi-123 me-2"></i>
                                            Número de Trámite
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="nro_tramite"
                                            value={formData.nro_tramite}
                                            onChange={handleChange}
                                            pattern="[0-9]{11}"
                                            title="Debe ingresar 11 números"
                                            minLength={11}
                                            required
                                            placeholder="Ingrese número de trámite..."
                                            className="shadow-sm"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            <i className="bi bi-calendar3 me-2"></i>
                                            Año de Nacimiento
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="anio_nac"
                                            value={formData.anio_nac}
                                            onChange={handleChange}
                                            pattern="[0-9]{4}"
                                            title="Debe ingresar 4 números"
                                            minLength={4}
                                            required
                                            placeholder="AAAA"
                                            className="shadow-sm"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="d-grid gap-2">
                                <Button 
                                    variant="success" 
                                    type="submit" 
                                    size="lg"
                                    className="mt-3"
                                >
                                    <i className="bi bi-check-circle me-2"></i>
                                    Registrar voto
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
        }

        {userPresencial.login &&
            <Container className="py-4">
                <Card className="border-0 shadow-sm">
                    <Card.Body className="text-center p-4">
                        <div className="mb-4">
                            <i className="bi bi-person-check-fill" style={{ fontSize: '3rem', color: '#198754' }}></i>
                        </div>
                        
                        <h2 className="display-6 mb-4" style={{ color: '#198754' }}>
                            Sesión Iniciada
                        </h2>
                        
                        <div className="d-flex justify-content-center align-items-center gap-3 mb-4">
                            <Badge bg="success" className="px-3 py-2">
                                <i className="bi bi-person me-2"></i>
                                {userPresencial.name_user}
                            </Badge>
                            <Badge bg="secondary" className="px-3 py-2">
                                <i className="bi bi-person-vcard me-2"></i>
                                DNI: {userPresencial.dni}
                            </Badge>
                        </div>

                        <Card className="border-success mb-4">
                            <Card.Body style={{ backgroundColor: '#f8fff8' }}>
                                <i className="bi bi-info-circle-fill text-success mb-3" style={{ fontSize: '1.5rem' }}></i>
                                <p className="mb-0">
                                    <strong>Usuario verificado correctamente</strong><br />
                                    Ya puede proceder con el registro del voto.
                                </p>
                            </Card.Body>
                        </Card>

                        <Button 
                            variant="outline-danger" 
                            onClick={handleLogout}
                            size="lg"
                            className="px-4"
                        >
                            <i className="bi bi-box-arrow-right me-2"></i>
                            Cerrar sesión
                        </Button>
                    </Card.Body>
                </Card>
            </Container>
        }
    </>
    );
};

export default VoterForm;